import { create } from 'zustand';

// Tracks which artifact answers are currently being AI-edited by the owner.
// Keyed by answer_id. Set by ARTIFACT_EDIT_STARTED, cleared by ARTIFACT_UPDATED.
// Collaborators read this to show an "Editing…" indicator on the Nebula canvas.
const useArtifactEditSignal = create((set) => ({
  editingAnswers: {},
  setEditing: (answerId) => set((state) => ({
    editingAnswers: { ...state.editingAnswers, [answerId]: true },
  })),
  clearEditing: (answerId) => set((state) => {
    const next = { ...state.editingAnswers };
    delete next[answerId];
    return { editingAnswers: next };
  }),
}));

export default useArtifactEditSignal;
